import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  getGAClientId()
  {
    let cookieVal = this.getGoogleAnalyticsCookieValue('_ga');
    let clientId = '';
    if(cookieVal)
    {
      let firstIndex = cookieVal.indexOf('.');
      let secondIndex = cookieVal.indexOf('.', firstIndex + 1);
      if(secondIndex >= 0 && secondIndex < cookieVal.length)
        clientId = cookieVal.substring(secondIndex + 1);
    }

    return clientId;
  }

  getGASessionId()
  {
    let cookieVal = this.getGoogleAnalyticsCookieValue('_ga_4F7NCDZF2K');
    let sessionId = '';
    if(cookieVal)
    {
      let segments = cookieVal.split('.');
      if(segments.length >= 3)
        sessionId = segments[2];
    }

    return sessionId;
  }

  private getGoogleAnalyticsCookieValue(cookieName: string){
    let gaValue = '';
    if(document.cookie)
    {
      let cookies = document.cookie.split(';');
      let gaCookie = cookies.find((el) => el.trim().split('=')[0] == cookieName);
      if(gaCookie)
      {
        let cookieKeyVal = gaCookie.split('=');
        if(cookieKeyVal.length > 1)
          gaValue = cookieKeyVal[1];
      }
    }

    return gaValue;
  }

  // hash a value
  public async hashValue(value : string | undefined) {
    if(value == undefined)
      return '';

    const msgBuffer = new TextEncoder().encode(value);
    // Hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }
  
  // hash and save cookie 
  public async saveHashedCookie(cookieName: string, value: string) {
    const hashHex = await this.hashValue(value);
    // Clear the cookie
    this.clearCookies(cookieName);
    // Save the hashed cookie
    document.cookie = `${cookieName}=${hashHex}; path=/; max-age=${60 * 60 * 24}`;
    //document.cookie = `${cookieName}=${hashHex}; path=/; SameSite=Strict; Secure"`;//NO expires or max-age
  }

  clearCookies(names: string | string[]): void {
    const cookieArray = Array.isArray(names) ? names : [names];
    cookieArray.forEach(name => {
      document.cookie = `${name.trim()}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });
  }
}
